import React, { lazy } from 'react';
import { createBrowserRouter, createMemoryRouter } from 'react-router-dom';
import { routes } from './routesConfig';
import { embedQuizType } from 'utils/commonFunctions';
import { QUIZ_TYPE_BGT, QUIZ_TYPE_CT } from 'utils/constants';

const App = lazy(() => import(/* webpackChunkName: "app" */ './Routelets/App'));
const QuizHome = lazy(() => import(/* webpackChunkName: "QuizHome" */ 'pages/QuizHome'));
const LeaderboardLanding = lazy(() =>
  import(/* webpackChunkName: "LeaderboardLanding" */ 'pages/LeaderboardLanding')
);
const Leaderboard = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/Leaderboard'));
const Rules = lazy(() => import(/* webpackChunkName: "Rules" */ 'pages/Rules'));
const Prizes = lazy(() => import(/* webpackChunkName: "Prizes" */ 'pages/Prizes'));
const Game = lazy(() => import(/* webpackChunkName: "Game" */ 'pages/Game'));
const Result = lazy(() => import(/* webpackChunkName: "Result" */ 'pages/Result'));

const quizType = embedQuizType(); // Assuming this function returns the quiz type
const isBgtQuizType = quizType === QUIZ_TYPE_BGT; // Check if the quiz type is 'bgt'
const isCTQuizType = quizType === QUIZ_TYPE_CT; // Check if the quiz type is 'champions-trophy'

export const router = createMemoryRouter(
  // export const router = createBrowserRouter(
  [
    {
      element: <App />,
      children: [
        {
          index: true,
          element: <QuizHome />
        },
        {
          path: routes.game,
          children: [
            {
              index: true,
              element: <Game />
            },
            {
              path: routes.result,
              element: <Result />
            }
          ]
        },
        {
          element: <Prizes />,
          path: routes.prizes
        },
        {
          path: routes.leaderboardLanding,
          children: [
            {
              index: true,
              element: (isBgtQuizType || isCTQuizType) ? <Leaderboard /> : <LeaderboardLanding />
            },
            {
              path: routes.leaderboard,
              element: <Leaderboard />
            }
          ]
        },
        {
          element: <Rules />,
          path: routes.rules
        }
      ]
    }
  ],
  {
    initialIndex: 0
  }
);
